<template>
  <ProductSerialNumbers @select-product-serial-number="openProductSerialNumber" />
</template>
<script>
import ProductSerialNumbers from "@/gapp-components/components/views/promotions/ProductSerialNumbers.vue";

export default {
  name: "SerialNumbersPage",
  metaInfo: {
    title: "VINs"
  },
  components: {
    ProductSerialNumbers
  },
  methods: {
    openProductSerialNumber(item) {
      this.$router.push({
        name: "productSerialNumber",
        params: {
          id: item.id
        }
      });
    }
  }
};
</script>
